<template>
    <span class="spinner">
        <v-icon>{{ icon }}</v-icon>
    </span>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

interface Props {
    icon?: string;
}

const props = withDefaults(defineProps<Props>(), {
    icon: 'mdi-loading'
});

const { icon } = toRefs(props);
</script>

<style scoped>
.spinner {
    display: inline-block;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
